import store from "../../store";
import { sendMapAction, openFolder, closeFolder } from "../MessageBus";
import { folderLocalStore } from "./LocalStorage";

export const closeFolderMap = (folderId) => {
  sendMapAction(closeFolder, folderId);
  const isOpen = isFolderOpen(folderId);

  if (isOpen == 2) {
    store.dispatch("removeFolderSecundary", folderId);
  } else if (isOpen == 1) {
    if (store.getters.getFolderSecundary.length > 0) {
      const folder = store.getters.getFolderSecundary[0];
      store.dispatch("setFolder", folder);
      store.dispatch("removeFolderSecundary", folder.id);
    } else {
      store.dispatch("setFolder", null);
    }
  }

  setStoreFoldersLocal();
};

export const isFolderOpen = (id) => {
  const folders = store.getters.getFolderSecundary;
  for (let i = 0; i < folders.length; i++) {
    if (folders[i].id == id) {
      return 2;
    }
  }
  return store.getters.getFolder && id == store.getters.getFolder.id ? 1 : 0;
};

const setStoreFoldersLocal = () => {
  folderLocalStore.set({
    user: store.getters.getUser.id,
    folder: store.getters.getFolder,
    folderSecundary: store.getters.getFolderSecundary
  });
};

const openSubFolders = (folder, openSubFolder, isOpenFolder, ignoreFolderControl) => {
  if (openSubFolder) {
    for (const subFolder of folder.children) {
      openSubFolders(subFolder, openSubFolder, isOpenFolder);
    }
  }

  if (isOpenFolder) {
    if (store.getters.getFolder && folder.id != store.getters.getFolder.id) {
      store.dispatch("addFolderSecundary", store.getters.getFolder);
    }
    store.dispatch("setFolder", folder);
    sendMapAction(openFolder, folder);
  } else {
    if (!ignoreFolderControl) closeFolderMap(folder.id);
  }

  setStoreFoldersLocal();
};

export const openFolderControl = async (item, openSubFolder, ignoreFolderControl) => {
  const isOpen = !isFolderOpen(item.id);

  openSubFolders(item, openSubFolder, isOpen, ignoreFolderControl);
};

export const selectSecundaryFolder = (folder) => {
  store.dispatch("removeFolderSecundary", folder.id);
  store.dispatch("addFolderSecundary", store.getters.getFolder);
  store.dispatch("setFolder", folder);
  setStoreFoldersLocal();
};
